// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"5bcffef6","523":"7172972d"}[chunkId] + ".chunk.css";
};